import Svg, { Path } from 'react-native-svg'

const ActionCardChevronSVG = ({ styleProps }: { styleProps?: object }) => (
  <Svg width={11} height={19} style={styleProps} fill="none">
    <Path
      fill="#21211F"
      d="m10.297 10.296-7.5 7.5a1.127 1.127 0 0 1-1.594-1.594L7.907 9.5 1.205 2.796a1.127 1.127 0 1 1 1.594-1.594l7.5 7.5a1.124 1.124 0 0 1-.002 1.594Z"
    />
  </Svg>
)
export default ActionCardChevronSVG
